// SECTION HEADING

export const API_SECTION_DISPLAY_OPTION_SVG = "svg";

export const SECTION_NAME_RENDER_SVG = "SECTION_NAME_RENDER_SVG";
